import { Command as CommandPrimitive } from "cmdk";
import { type ComponentProps } from "react";

import { cn } from "../../utils";

export type CommandListProps = typeof CommandPrimitive.List;

const List = ({ ref, className, ...props }: ComponentProps<CommandListProps>) => (
  <CommandPrimitive.List
    ref={ref}
    className={cn("max-h-[300px] overflow-x-hidden overflow-y-auto", className)}
    {...props}
  />
);

List.displayName = CommandPrimitive.List.displayName;

export default List;
